module.exports = __webpack_public_path__ + "static/media/cylinder_body.47cf873d.png";